'use strict';

import GLightbox from 'glightbox'

const SELECTOR = 'js-video-modal';

export function init() {
    const element = document.querySelector('.' + SELECTOR);

    if (element === null) {
        return false;
    }

    if (window.innerWidth > 600) {
        GLightbox({
            selector: SELECTOR,
            videosWidth: 1280
        });
    }
}

export default { init }
